module.exports = __webpack_public_path__ + "img/banner-01.c87fd341.jpg";